export function isExceptionLikeObject(obj: unknown) {
  return (
    obj instanceof Error ||
    (typeof obj === 'object' &&
      obj !== null &&
      Object.hasOwn(obj, 'name') &&
      Object.hasOwn(obj, 'message'))
  );
}
